const items = [
  {
    id: 'cmt-1',
    name: '吃瓜不嫌事大',
    time: '2小时前',
    content: '这个平台真的太强了！每次有网红出事先来这里看，信息更新比微博还快，而且整理得特别清楚。今天的直播翻车专题看得太过瘾了，建议所有追瓜的人都收藏这个站。',
    likes: 1283,
  },
  {
    id: 'cmt-2',
    name: '理性吃瓜群众',
    time: '5小时前',
    content: '关注网红爆料三个月了，最欣赏的是每条爆料都有来源标注，不会像其他平台那样乱传谣言。MCN内幕那个系列我每一期都追，学到了很多行业内幕知识，吃瓜也能吃出深度。',
    likes: 967,
  },
  {
    id: 'cmt-3',
    name: '资深追瓜人',
    time: '8小时前',
    content: '从去年开始就在这里追瓜了，亲眼看着内容越做越好。特别是热点榜单和焦点专题两个板块，信息梳理得太清晰了，再也不用在各大平台来回切换找瓜吃了。已经安利给身边所有朋友！',
    likes: 756,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-6 bg-primary-500 rounded-full"></div>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">读者评论</h2>
          <span className="text-xs text-foreground-500 bg-secondary-100 px-2 py-0.5 rounded-full">真实反馈</span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {items.map((item) => (
            <div key={item.id} className="bg-background-50 rounded-lg border border-secondary-200/60 p-5 flex flex-col">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-accent-600 font-bold text-sm">{item.name.charAt(0)}</span>
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">{item.name}</div>
                  <div className="text-xs text-foreground-500">{item.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed flex-1 mb-3">{item.content}</p>
              <div className="flex items-center gap-1 text-xs text-foreground-500">
                <i className="ri-thumb-up-line text-accent-500"></i>
                <span>{item.likes.toLocaleString()} 人觉得有用</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}